import { createSlice } from "@reduxjs/toolkit";

const uploadFileModule = createSlice({
  name: "uploadFileModule",
  initialState: {
    isLoading: false,
    data: null,
    files: null,
    selected_modules: [],
    selected_module_id: null,
    isError: false,
  },
  reducers: {
    setUploadFileModule_Data: (state, action) => {
      state.data = action.payload;
    },
    setUploadFileModule_Files: (state, action) => {
      state.files = action.payload;
    },
    setSelectedModules: (state, action) => {
      if (action.payload === "remove") {
        state.selected_modules = [];
      } else {
        const idExists = state.selected_modules.some(
          (item) => item.module_id === action.payload.module_id
        );
        if (!idExists) {
          state.selected_modules.push(action.payload); // Only push if there is no object with the same ID
        }
      }
    },
    setSelectedModuleID: (state, action) => {
      state.selected_module_id = action.payload;
    },
  },
});

export const {
  setUploadFileModule_Data,
  setUploadFileModule_Files,
  setSelectedModules,
  setSelectedModuleID,
} = uploadFileModule.actions;
export default uploadFileModule.reducer;
